import React from 'react';
import { observer } from 'mobx-react';
import classes from 'classnames';
import { useTranslation, Trans } from 'react-i18next';
import { resourcePath } from '../../../utils/helpers';
import './illustration.scss';
import { Image } from '../../design-system/containers';
import { Heading1 } from '../../design-system/headings';
import { TextLead, TextTiny } from '../../design-system/texts';

/*
    Presentation handles multiple images.
    - To use, supply array to image property of presentation definition instead of string -
    Example: "image": ["/static/img/assessment/ws4_presentation_1.jpg", "/static/img/assessment/ws4_presentation_2.jpg"]
    */

export const Illustration = observer(({ ui }) => {
    const { t } = useTranslation('assessment');
    const [imageZoomed, setIsImageZoomed] = React.useState(false);

    const imageProp =
        ui.image !== undefined && ui.image !== null && ui.image !== ''
            ? ui.image
            : ui.imageUrl;

    const handleImageClick = () => {
        setIsImageZoomed(!imageZoomed);
    };

    const renderImage = (imageSrc, imageZoom) => {
        return (
            <div className={classes('image', { clickable: imageZoom })}>
                {imageZoom && (
                    <Image
                        src={resourcePath(imageSrc)}
                        alt={t('illustration')}
                        onClick={handleImageClick}
                        className="presentationImage"
                    />
                )}
                {!imageZoom && (
                    <Image
                        fullWidth
                        src={resourcePath(imageSrc)}
                        alt={t('illustration')}
                    />
                )}
            </div>
        );
    };

    return (
        <div className="assessment-presentation">
            <div className="question">
                {ui.pretitle ? <TextTiny>{t(ui.pretitle)}</TextTiny> : null}
                {ui.title ? <Heading1 mb={8}>{t(ui.title)} </Heading1> : null}
                {ui.description ? (
                    <Trans components={{ p: <TextLead /> }}>
                        {t(ui.description)}
                    </Trans>
                ) : null}
                {Array.isArray(imageProp) ? (
                    <div className="imageContainer">
                        {imageProp.map((imageSrc) => {
                            return renderImage(imageSrc, ui.imageZoom);
                        })}
                    </div>
                ) : imageProp ? (
                    renderImage(imageProp, ui.imageZoom)
                ) : null}

                {ui.imageZoom ? (
                    <div
                        className="image-zoomed"
                        onClick={handleImageClick}
                        style={{
                            opacity: imageZoomed ? '1' : '0',
                            visibility: imageZoomed ? 'visible' : 'hidden',
                        }}
                    >
                        <Image
                            src={resourcePath(ui.imageZoom)}
                            alt={t('illustration')}
                            onClick={handleImageClick}
                        />
                    </div>
                ) : null}
            </div>
        </div>
    );
});
